import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class UPIListUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getUPIList(req);
    }
}
export default UPIListUseCase;
